import { IsWorker } from "@pdfking/storage"

import create_app from "./create_app"

// esbuild might be packaging this code in a worker env, which results in window being undefined
// since any of this code is used, we simply drop the initialization of virtual components

export default app => {
  if (!app.render) app.render = () => null // disable vue warning for missing render function
  if (!IsWorker())
    return create_app({
      app,
      el: document.createElement("div"),
    })
}
